"use client";

import React from "react";
import { Dropdown } from "flowbite-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";

import { Logo } from "../../assets/logo";

const LINKS: any = {
  Home: {
    value: "",
  },
  Team: {
    child: [
      { text: "Team", href: "/team" },
      { text: "Attribution", href: "/attributions" },
    ],
  },
  Project: {
    child: [
      { text: "Description", href: "/description" },
      { text: "Contribution", href: "/contribution" },
      { text: "Engineering Success", href: "/engineering" },
      { text: "Experiments", href: "/project/experiments" },
      { text: "Model", href: "/model" },
      { text: "Hardware", href: "/hardware" },
      { text: "Implementation", href: "/project/implementation" },
      { text: "Notebook", href: "/project/notebook" },
      {
        text: "Plant synthetic biology",
        href: "/project/plant-synthetic-biology",
      },
      { text: "Proof of Concept", href: "/project/proof-of-concept" },
      { text: "Results", href: "/project/results" },
      { text: "Awards", href: "/project/awards" },
    ],
  },
  Parts: {
    child: [
      { text: "Part Collection", href: "/ionis-paris/part-collection" },
      {
        text: "Parts",
        href: "https://parts.igem.org/cgi/partsdb/pgroup.cgi?pgroup=iGEM2023&group=Ionis-Paris",
      },
    ],
  },
  Safety: {
    value: "/safety",
  },
  "Human Practices": {
    child: [
      { text: "Integrated Human Practices", href: "/human-practices" },
      { text: "Education", href: "/education" },
      {
        text: "Sustainable Development",
        href: "/human-practices/sustainable-development",
      },
      { text: "Entrepreneurship", href: "/entrepreneurship" },
    ],
  },
};

function Navbar({ fixed }: any) {
  const [navbarOpen, setNavbarOpen] = React.useState(false);
  return (
    <nav className="flex absolute w-full flex-wrap justify-between items-center px-2 py-2 mb->3 h-[90px] z-10">
      <div className="container flex flex-wrap justify-between items-center px-4 mx-auto">
        <div className="flex relative justify-between w-full lg:w-auto lg:static lg:block lg:justify-start">
          <a
            className="inline-block py-2 mr-4 text-sm w-[70px] h-[70px] font-bold leading-relaxed text-white uppercase whitespace-nowrap"
            href={process.env.PUBLIC_URL}
          >
            <Logo />
          </a>
          <button
            className="block px-3 py-1 text-xl leading-none bg-transparent rounded border border-transparent border-solid cursor-pointer outline-none text-ThemeGray lg:hidden focus:outline-none"
            type="button"
            onClick={() => setNavbarOpen(!navbarOpen)}
          >
            <FontAwesomeIcon icon={faBars} />
          </button>
        </div>
        <div
          className={
            "lg:flex flex-grow items-center" +
            (navbarOpen
              ? " flex absolute left-0 top-[90px] w-full border-BleuClair border-b-2 bg-white"
              : " hidden")
          }
          id="example-navbar-danger"
        >
          <ul className="flex flex-col gap-8 w-full list-none md:w-auto lg:flex-row lg:ml-auto">
            {Object.keys(LINKS).map((key: string, index: number) => {
              return (
                <li
                  className="w-full md:w-auto nav-item  flex items-center
                   px-[48px] py-2 text-[16px] font-inherit md:px-2"
                  key={index}
                >
                  {"value" in LINKS[key] ? (
                    <a
                      href={process.env.PUBLIC_URL + LINKS[key].value}
                      key={index}
                    >
                      <span>{key}</span>
                    </a>
                  ) : (
                    <Dropdown inline label={key} key={index}>
                      {LINKS[key].child.map((child: any, _indx: any) => {
                        return (
                          <Dropdown.Item
                            href={
                              ("Parts" == key ? "" : process.env.PUBLIC_URL) +
                              child.href
                            }
                            key={_indx}
                          >
                            {child.text}
                          </Dropdown.Item>
                        );
                      })}
                    </Dropdown>
                  )}
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </nav>
  );
}
export default Navbar;
